module.exports = __webpack_public_path__ + "assets/img/open.90856b4f.png";